module.exports = __webpack_public_path__ + "dist/img/design.f355725b.jpg";